import $ from "jquery";
import { isMobile } from './util';

export class TimelineItem {
  constructor(element, timeline) {
    const _self = this;
    this.element = element;
    this.tl = null;
    this.index = null;
    this.isOpen = false;
    this.overlayCard = $(".overlay-card", element);
    this.openToRight = this.decideDirection(); 
    this.category = $(this.element).data('category');

    $(this.element).on("click", function () {
      _self.handleClick();
    });
    $(window).on("resize", function () {
      console.log("item handles resize");
      _self.decideDirection();
    });
  }

  decideDirection() {
    const gridWidth = this.element.parentElement.getBoundingClientRect().width;
    const positionX = this.element.getBoundingClientRect().x;
    const openToRight = gridWidth * 0.5 > positionX ? true : false; 

    return openToRight;
  }

  handleClick() {
    if (this.isOpen) {
      this.closeOverlay();
    } else {
      this.openOverlay();
    }
  }

  openOverlay() {
    if (isMobile()) {
      console.log("open swiper", isMobile());
      this.tl.swiper.slideTo(this.index, 0);
    } else {
      const openToRight = this.decideDirection();
      if (openToRight) { 
        $(this.element).addClass('open-right');
        $(this.element).removeClass('open-left');
      } else {
        $(this.element).addClass('open-left');
        $(this.element).removeClass('open-right'); 
      }

      $(this.element).addClass("active-overlay");
      $(this.overlayCard).fadeIn();
    }

    $(this).trigger("openOverlayEvent");

    this.isOpen = true;
  }

  closeOverlay() { 
    const _self = this;
    $(this.overlayCard).fadeOut(300, function () {
      $(_self.element).removeClass("active-overlay");
    });

    if (isMobile()) {
      console.log("close swiper", isMobile());
    }

    $(this).trigger("closeOverlayEvent");

    this.isOpen = false;
  }

  initialHide() {
    const _self = this;
    return new Promise(function(resolve, reject) {
      if (_self.overlayCard.length > 0) {
        _self.overlayCard.hide();
        resolve('initialHide succesfull');
      } else if ($(_self.element).hasClass('birthday-item--year')) {
          resolve('initialHide succesfull (year item)');
      } else {
          reject('error on initialHide');

      } 
    }); 
  }

  setTimeline(timeline) {
    this.tl = timeline;
  }

  setIndex(index) {
    this.index = index;
  }
}
